(function () {
var $, animationEndSupport;

$ = jQuery;

animationEndSupport = false;

$(function() {
  var s;
  s = (document.body || document.documentElement).style;
  return animationEndSupport = s.animation !== void 0 || s.WebkitAnimation !== void 0 || s.MozAnimation !== void 0 || s.MsAnimation !== void 0 || s.OAnimation !== void 0;
});

hubspot.define('vex', ['jQuery'], function($) {
  return {
    legacyInternalHsVersion: 1,
    globalID: 1,
    animationEndEvent: 'animationend webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend',
    baseClassNames: {
      content: 'vex-content',
      overlay: 'vex-overlay',
      close: 'vex-close',
      animating: 'vex-animating'
    },
    defaultOptions: {
      content: '',
      showCloseButton: true,
      overlayClosesOnClick: true,
      appendLocation: 'body',
      className: '',
      css: {},
      overlayClassName: '',
      overlayCSS: {},
      closeClassName: '',
      closeCSS: {}
    },
    open: function(options) {
      var $closeButton, $vexContent, $vexOverlay;
      options = $.extend(true, {}, vex.defaultOptions, options);
      options.id = vex.globalID;
      vex.globalID += 1;
      $vexOverlay = $('<div>').addClass(vex.baseClassNames.overlay).addClass(options.overlayClassName).css(options.overlayCSS).data({
        vex: options
      });
      if (options.overlayClosesOnClick) {
        $vexOverlay.click(function(e) {
          if (e.target !== this) {
            return;
          }
          return vex.close($(this).data().vex.id);
        });
      }
      $vexContent = $('<div>').addClass(vex.baseClassNames.content).addClass(options.className).css(options.css).append(options.content).data({
        vex: options
      });
      $vexOverlay.append($vexContent);
      if (options.showCloseButton) {
        $closeButton = $('<div>').addClass(vex.baseClassNames.close).addClass(options.closeClassName).css(options.closeCSS).data({
          vex: options
        });
        $closeButton.click(function() {
          return vex.close($(this).data().vex.id);
        });
        $vexContent.append($closeButton);
      }
      $(options.appendLocation).append($vexOverlay);
      options.$vexContent = $vexContent;
      options.$vexOverlay = $vexOverlay;
      $vexContent.data({
        vex: options
      });
      if (options.afterOpen) {
        options.afterOpen($vexContent, options);
      }
      setTimeout((function() {
        return $vexContent.trigger('vexOpen', options);
      }), 0);
      return $vexContent;
    },
    getAllVexes: function() {
      return $("." + vex.baseClassNames.content + ":not(\"." + vex.baseClassNames.animating + "\")");
    },
    close: function(id) {
      var $lastVexContent;
      if (!id) {
        $lastVexContent = vex.getAllVexes().last();
        if (!$lastVexContent.length) {
          return;
        }
        id = $lastVexContent.data().vex.id;
      }
      if (!id) {
        return false;
      }
      return vex.closeByID(id);
    },
    closeAll: function() {
      var ids;
      ids = vex.getAllVexes().map(function() {
        return $(this).data().vex.id;
      });
      if (!(ids && ids.length)) {
        return false;
      }
      if (ids.toArray) {
        ids = ids.toArray();
      }
      $.each(ids.reverse(), function(index, id) {
        return vex.closeByID(id);
      });
      return true;
    },
    closeByID: function(id) {
      var $vexContent, $vexOverlay, beforeClose, close, options;
      $vexOverlay = $('.' + vex.baseClassNames.overlay).filter(function() {
        return $(this).data().vex.id === id;
      });
      $vexContent = $vexOverlay.find('.' + vex.baseClassNames.content);
      options = $.extend(true, {}, $vexContent.data().vex);
      beforeClose = function() {
        if (options.beforeClose) {
          return options.beforeClose($vexContent, options);
        }
      };
      close = function() {
        $vexContent.trigger('vexClose', options);
        $vexOverlay.remove();
        if (options.afterClose) {
          return options.afterClose($vexContent, options);
        }
      };
      if (animationEndSupport) {
        beforeClose();
        $vexOverlay.unbind(vex.animationEndEvent).bind(vex.animationEndEvent, function() {
          return close();
        }).addClass(vex.baseClassNames.animating);
      } else {
        beforeClose();
        close();
      }
      return true;
    },
    hideLoading: function() {
      return $('.vex-loading-spinner').remove();
    },
    showLoading: function($el) {
      if ($el == null) {
        $el = $('body');
      }
      vex.hideLoading();
      return $el.append('<div class="vex-loading-spinner"></div>');
    }
  };
});
}());

